import './instance';
import './resources/css/style.css';

// register create function for bundleid
Oskari.bundle('asdi-projection-change', function () {
  return Oskari.clazz.create('Oskari.projection.change.instance', 'projection-change');
});